if (!customElements.get('video-carousel')) {
  class VideoCarousel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.video-carousel__items',
        nextEl: '.swiper-btn-next',
        prevEl: '.swiper-btn-prev',
        item: '.video-carousel__item',
        toggle: '.video-carousel__toggle',
        videoElement: 'video-element',
      };
      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
        playing: 'is-playing',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

      this.enableSlider = this.dataset.enableSlider === 'true';
      this.pauseOthers = this.dataset.pauseOthers === 'true';
      this.items = parseInt(this.dataset.items);
      this.tabletItems = parseInt(this.dataset.tabletItems);

      this.sliderInstance = false;

      this.initPlayback();

      if (this.enableSlider) {
        this.init();
        document.addEventListener('matchMobile', () => this.init());
        document.addEventListener('unmatchMobile', () => this.init());
      }
    }

    initPlayback() {
      this.querySelectorAll(this.selectors.item).forEach((item) => {
        const videoElement = item.querySelector(this.selectors.videoElement);
        const toggle = item.querySelector(this.selectors.toggle);
        if (!videoElement || !toggle) return;

        toggle.addEventListener('click', (event) => {
          event.preventDefault();
          if (videoElement.hasAttribute('playing')) {
            videoElement.pause();
          } else {
            videoElement.play();
          }
        });

        videoElement.addEventListener('video:play', () => {
          item.classList.add(this.classes.playing);
          toggle.setAttribute('aria-label', toggle.dataset.pauseLabel || 'Pause video');
          if (this.pauseOthers) this.pauseOthersExcept(videoElement);
        });

        videoElement.addEventListener('video:pause', () => {
          item.classList.remove(this.classes.playing);
          toggle.setAttribute('aria-label', toggle.dataset.playLabel || 'Play video');
        });
      });
    }

    pauseOthersExcept(current) {
      this.querySelectorAll(this.selectors.videoElement).forEach((videoElement) => {
        if (videoElement !== current && videoElement.hasAttribute('playing')) {
          videoElement.pause();
        }
      });
    }

    init() {
      if (FoxTheme.config.mqlMobile) {
        this.destroySlider();
      } else {
        this.initSlider();
      }
    }

    initSlider() {
      const columnGap = FoxTheme.utils.getGridColumnGap(this.sliderWrapper);

      const sliderOptions = {
        slidesPerView: this.tabletItems,
        spaceBetween: columnGap.tablet,
        navigation: {
          nextEl: this.section.querySelector(this.selectors.nextEl),
          prevEl: this.section.querySelector(this.selectors.prevEl),
        },
        pagination: false,
        breakpoints: {
          1024: {
            slidesPerView: this.items,
            spaceBetween: columnGap.desktop,
          },
        },
        threshold: 2,
        watchOverflow: true,
      };

      if (typeof this.sliderInstance !== 'object') {
        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);
        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();
      }

      if (Shopify.designMode && typeof this.sliderInstance === 'object') {
        document.addEventListener('shopify:block:select', (e) => {
          if (e.detail.sectionId != this.sectionId) return;
          const index = Number(e.target.dataset.index);
          this.sliderInstance.slider.slideTo(index);
        });
      }
    }

    destroySlider() {
      this.classList.remove(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
      this.sliderWrapper.classList.add(this.classes.grid);
      if (typeof this.sliderInstance === 'object') {
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }
  }
  customElements.define('video-carousel', VideoCarousel);
}
